import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full border-brand-gold/15 bg-white/80 shadow-sm" data-id="element-325">
    <div className="flex items-center mb-4" data-id="element-326">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-gold/10 flex items-center justify-center text-brand-darkGreen font-serif font-bold text-sm md:text-xl border border-brand-gold/30 mr-3 md:mr-4 shrink-0 shadow-sm" data-id="element-327">
        {initials}
      </div>
      <div data-id="element-328">
        <div className="flex text-brand-gold mb-1 text-[15px] md:text-lg" data-id="element-329">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-330" />)}
        </div>
        <div className="font-medium text-brand-darkGreen md:text-lg" data-id="element-331">
          {name}
        </div>
        <div className="text-xs md:text-sm text-brand-muted" data-id="element-332">{location}</div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px] md:text-base font-serif leading-relaxed" data-id="element-333">
      "{text}"
    </p>
  </div>;
export const MoreTestimonials = () => {
  const testimonials = [{
    initials: 'AG',
    name: 'Andrea G.',
    location: 'La Plata, Buenos Aires',
    text: 'Tenía el negocio muerto hace 4 meses. Hice el ritual del Volumen 4 un lunes y el miércoles tuve más movimiento que en las últimas 3 semanas juntas. Ahora lo hago todos los meses.'
  }, {
    initials: 'DM',
    name: 'Diego M.',
    location: 'Mendoza',
    text: 'Lo del sellado de los rincones me cambió la cabeza. Desde que lo apliqué dejaron de aparecer gastos de la nada. Parece mentira pero mi economía se estabilizó de una forma que no puedo explicar.'
  }, {
    initials: 'LR',
    name: 'Lorena R.',
    location: 'Tucumán',
    text: 'El Oráculo de la Billetera es lo más práctico que usé en mi vida. 60 segundos antes de abrir Mercado Pago y siento que el dinero fluye diferente. Mis ventas online subieron un 40% en un mes.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-334">
      <div className="text-center mb-12" data-id="element-335">
        <h2 className="md:text-4xl font-display font-bold mb-4 text-[24px] text-brand-darkGreen pt-[0px]" data-id="element-336">
          ❤️ MÁS PERSONAS QUE YA CAMBIARON SU ENERGÍA
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px] md:text-sm max-w-6xl mx-auto" data-id="element-337">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-338" />)}
      </div>
    </Section>;
};